import React from "react";
import FaqQuestion from "../../../core/components/cards/faq_questions_card/faq_questions_card.jsx";
import "./frequently_asked_questions_view.css";
import { frequentlyAskedQuestionsMapper } from "../utils/mapper/frequently_asked_questions_mapper.jsx";

const FrequentlyAskedQuestionsView = () => {
    const { title, faqData } = frequentlyAskedQuestionsMapper;
    return (
        <div className="frequently_asked_questions">
            <div className="container">
                <div className="title">
                    <h1>{title}</h1>
                </div>
                {faqData.map((faq, index) => (
                    <FaqQuestion
                        key={index}
                        question={faq.question}
                        answer={faq.answer}
                    />
                ))}
            </div>
        </div>
    );
};

export default FrequentlyAskedQuestionsView;
